import React, { useEffect, useState } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { useParams, useHistory } from 'react-router-dom'
import { usePage, useAuth } from 'hooks'
import { getReportName } from 'utils/report'
import ReportViewContainer from './ReportViewContainer'
import { Box } from 'elements'
import ReportWatcher from '../ReportWatcher'
import { NotFoundPage } from 'pages'

export default function ReportContainer() {
  const { setHeader } = usePage()
  const { currentOrg } = useAuth()
  const { reportId } = useParams()
  const history = useHistory()
  const [resolutionAnomalyView, setResolutionAnomalyView] = useState('all')
  const [resolutionSection, setResolutionSection] = useState('forReview')

  const data = useLazyLoadQuery(
    graphql`
      query ReportContainerQuery(
        $reportId: ID!
        $resolutionSection: String = "forReview"
        $anomalies: [String] = null
      ) {
        reportById(id: $reportId) {
          rowId
          name
          company {
            id
            name
          }
          ...ReportViewContainer_report
          ...ReportContent_report
          ...ReportResolution_report
          ...ReportResolutionTable_report
        }
      }
    `,
    { reportId },
  )

  useEffect(() => {
    if (!data?.reportById) {
      return
    }

    const crumbs = [
      {
        label: 'Reports',
        value: 'reports',
        href: `/orgs/${currentOrg.slug}/companies/${data.reportById.company.id}/reports`,
      },
      { label: getReportName(data.reportById), value: data.reportById.rowId },
    ]

    setHeader({ crumbs })
  }, [data, setHeader, history, currentOrg])

  if (!data) {
    return null
  }

  if (!data.reportById) {
    return <NotFoundPage errorMessage="We couldn't find that report." />
  }

  return (
    // 300px for the width of the report menu
    <Box pl="300px">
      <ReportWatcher
        reportId={reportId}
        resolutionSection={resolutionSection}
        resolutionAnomalyView={resolutionAnomalyView}
      />
      <ReportViewContainer
        report={data.reportById}
        resolutionSection={resolutionSection}
        resolutionAnomalyView={resolutionAnomalyView}
        onResolutionSectionChange={setResolutionSection}
        onAnomalyViewChange={setResolutionAnomalyView}
      />
    </Box>
  )
}
